import { BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
import { PaginatedResults } from "shared/api/types/pagination";
import { SocietyParamsInput } from "shared/api/types/society/[societyId]";
import {
  SocietyFileAPIPathOutput,
  SocietyFilePostBodyInput,
  SocietyFileInfoOutput,
} from "shared/api/types/society/[societyId]/files/index";
import { FileView } from "shared/mappers/database/files/file";
export const getSocietyFilesContract: BaseApiContract<
  SocietyParamsInput,
  undefined,
  PaginatedResults<FileView, SocietyFileAPIPathOutput>
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/files",
  paramsType: {} as SocietyParamsInput,
  responseType: {} as PaginatedResults<FileView, SocietyFileAPIPathOutput>,
};
export const postSocietyFilesContract: BaseApiContract<
  SocietyParamsInput,
  SocietyFilePostBodyInput,
  SocietyFileInfoOutput
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/files",
  paramsType: {} as SocietyParamsInput,
  bodyType: {} as SocietyFilePostBodyInput,
  responseType: {} as SocietyFileInfoOutput,
};
